export const en_US = {
  translation: {
    'Welcome to React': 'Welcome to React and react-i18next',
  },
};
